(function(){
  'use strict';

  function ready(callback){
    if(document.readyState !== 'loading'){
      callback();
      return;
    }
    document.addEventListener('DOMContentLoaded', callback);
  }

  function normalize(value){
    return (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  var commonCurrencySearches = {
    'usd': ['united states'],
    'us dollar': ['united states'],
    'u.s. dollar': ['united states'],
    'cad': ['canada'],
    'canadian dollar': ['canada'],
    'gbp': ['united kingdom'],
    'pound': ['united kingdom'],
    'aud': ['australia'],
    'australian dollar': ['australia'],
    'eur': ['france','germany','italy','spain','netherlands','ireland','portugal','belgium','austria'],
    'euro': ['france','germany','italy','spain','netherlands','ireland','portugal','belgium','austria']
  };

  function getPriorityCountries(query){
    var cleaned = normalize(query).replace(/\s+/g, ' ');
    return commonCurrencySearches[cleaned] || null;
  }

  ready(function(){
    document.querySelectorAll('.pk-locale').forEach(function(locale, index){
      var list = locale.querySelector('.pk-locale__list');
      if(!list || locale.querySelector('.pk-locale-search')) return;

      var inputId = 'PkLocaleSearch-' + index;
      var label = document.createElement('label');
      label.className = 'pk-locale-search__label';
      label.setAttribute('for', inputId);
      label.textContent = 'Search country or currency';

      var input = document.createElement('input');
      input.id = inputId;
      input.className = 'pk-locale-search';
      input.type = 'search';
      input.autocomplete = 'off';
      input.placeholder = 'Search country or currency';
      input.setAttribute('aria-label', 'Search country or currency');

      var empty = document.createElement('div');
      empty.className = 'pk-locale-search__empty';
      empty.hidden = true;
      empty.textContent = 'No matching country or currency found.';

      list.parentNode.insertBefore(label, list);
      list.parentNode.insertBefore(input, list);
      list.parentNode.insertBefore(empty, list);

      function filterOptions(){
        var query = normalize(input.value);
        var priorityCountries = getPriorityCountries(query);
        var visibleCount = 0;

        list.querySelectorAll('li').forEach(function(item){
          var button = item.querySelector('.pk-locale__option');
          var rowText = normalize(item.textContent);
          var valueText = button ? normalize(button.value || '') : '';
          var searchableText = rowText + ' ' + valueText;
          var isMatch;

          if(priorityCountries){
            isMatch = priorityCountries.some(function(country){
              return rowText.indexOf(country) !== -1 || valueText.indexOf(country) !== -1;
            });
          } else {
            isMatch = !query || searchableText.indexOf(query) !== -1;
          }

          item.hidden = !isMatch;
          if(isMatch) visibleCount += 1;
        });

        empty.hidden = visibleCount !== 0;
      }

      input.addEventListener('input', filterOptions);
      input.addEventListener('keydown', function(event){
        if(event.key === 'Escape'){
          locale.removeAttribute('open');
        }
      });

      locale.addEventListener('toggle', function(){
        if(locale.open){
          window.setTimeout(function(){
            input.focus();
            input.select();
          }, 80);
        } else {
          input.value = '';
          filterOptions();
        }
      });
    });
  });
})();
